module.exports = __webpack_public_path__ + "img/pala_negra_padel.15a42214.jpg";